export default "__VITE_ASSET__DsM$xH_T__"